import React from 'react';
import RootSvg, { RootSvgProps } from '@/components/icons/RootSvg';

export default function SvgLoginOut(props: RootSvgProps) {
  return (
    <RootSvg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M26.2395 23.2589L16.7592 28.7323C16.5284 28.866 16.2665 28.9365 15.9998 28.9367C15.7331 28.9369 15.471 28.8668 15.24 28.7335L5.75851 23.2579C5.52786 23.1247 5.33633 22.9332 5.20316 22.7025C5.07 22.4719 4.99989 22.2102 4.99989 21.9439L4.99866 10.9949C4.99866 10.7282 5.06896 10.4662 5.20249 10.2353C5.33601 10.0044 5.52804 9.81281 5.75921 9.67979L15.2395 4.20634C15.4703 4.07265 15.7322 4.00215 15.9989 4.00195C16.2657 4.00176 16.5277 4.07187 16.7587 4.20523L26.2402 9.68081C26.4709 9.81398 26.6624 10.0055 26.7956 10.2362C26.9287 10.4668 26.9988 10.7284 26.9988 10.9948L27.0001 21.9438C27.0001 22.2105 26.9298 22.4725 26.7962 22.7034C26.6627 22.9343 26.4707 23.1259 26.2395 23.2589ZM6.13852 10.3368C6.02249 10.4032 5.92606 10.499 5.85899 10.6147C5.79192 10.7303 5.7566 10.8616 5.7566 10.9953L5.75784 21.9443C5.75784 22.0775 5.79289 22.2083 5.85947 22.3236C5.92606 22.4389 6.02182 22.5347 6.13715 22.6013L15.6187 28.0769C15.7344 28.1437 15.8658 28.1788 15.9995 28.1785C16.1332 28.1782 16.2644 28.1427 16.3799 28.0754L25.8602 22.6019C25.9762 22.5355 26.0727 22.4397 26.1397 22.324C26.2068 22.2084 26.2421 22.0771 26.2421 21.9434L26.2409 10.9944C26.2409 10.8612 26.2058 10.7304 26.1392 10.6151C26.0727 10.4998 25.9769 10.404 25.8616 10.3374L16.38 4.86182C16.2643 4.79498 16.1329 4.75992 15.9992 4.76018C15.8656 4.76045 15.7343 4.79603 15.6188 4.86333L6.13852 10.3368Z"
        fill="#64748B"
        stroke="#64748B"
      />
      <ellipse cx="16" cy="16" rx="3" ry="3" fill="#64748B" />
    </RootSvg>
  );
}
